import { FormattedMessage, FormattedNumber } from 'react-intl';
import ButtonGroup from '../../components/ButtonGroup/ButtonGroup';
import noop from '../../utils/noop';
import React from 'react';
import searchDisplayTypes from '../../enums/searchDisplayTypes';
import styles from './SearchResultTabButtons.module.scss';

const formatNumber = num => {
    let toReturn = num;
    if (num >= 1000000) {
        toReturn = `${Math.floor(toReturn / 1000000)}m+`;
    } else if (num >= 1000) {
        toReturn = `${Math.floor(toReturn / 1000)}k+`;
    }
    return toReturn;
};

type Props = $ReadOnly<{|
    changeSearchStatus: Function,
    displayMode: string,
    isLoading: boolean,
    liveItemsFound: number,
    soldItemsFound: number,
|}>;

const SearchResultTabButtons = (props: Props) => {
    const { changeSearchStatus, displayMode, isLoading, liveItemsFound, soldItemsFound } = props;
    return (
        <ButtonGroup
            buttons={[
                {
                    className: styles.button,
                    id: searchDisplayTypes.DISPLAY_AUCTION,
                    label:
                        !isNaN(liveItemsFound) && !isLoading ? (
                            <FormattedMessage
                                id="auction_total"
                                values={{ total: <FormattedNumber value={liveItemsFound} /> }}
                            />
                        ) : (
                            <FormattedMessage id="auction" />
                        ),
                    onClick:
                        displayMode !== searchDisplayTypes.DISPLAY_AUCTION
                            ? () => changeSearchStatus(searchDisplayTypes.DISPLAY_AUCTION)
                            : noop,
                    selected: displayMode === searchDisplayTypes.DISPLAY_AUCTION,
                },
                {
                    className: styles.button,
                    id: searchDisplayTypes.DISPLAY_PRICE_RESULTS,
                    label:
                        !isNaN(soldItemsFound) && !isLoading ? (
                            <FormattedMessage
                                id="price_results_total"
                                values={{ total: formatNumber(soldItemsFound) }}
                            />
                        ) : (
                            <FormattedMessage id="price_results" />
                        ),
                    onClick:
                        displayMode !== searchDisplayTypes.DISPLAY_PRICE_RESULTS
                            ? () => changeSearchStatus(searchDisplayTypes.DISPLAY_PRICE_RESULTS)
                            : noop,
                    selected: displayMode === searchDisplayTypes.DISPLAY_PRICE_RESULTS,
                },
            ]}
        />
    );
};

export default React.memo(SearchResultTabButtons);
